import magnifiAPIInstance from "./apiInstance";

export const reservedChannelAPIs = {
  getReservedChannels: ({ payload }) => magnifiAPIInstance.post(`/reserved/list_channel`, payload),
  addReservedChannel: ({ payload }) => magnifiAPIInstance.post(`/reserved/add_channel`, payload),
  updateReservedChannel: ({ payload }) => magnifiAPIInstance.post(`/reserved/update_channel`, payload),
  deleteReservedChannel: ({ payload }) => magnifiAPIInstance.delete(`/reserved/delete_channel/${payload.channelId}`),
};
